import UrgencyMessage from './components/UrgencyMessage/UrgencyMessage';
import DestinationMessage from './components/DestinationMessage/DestinationMessage';

export {
    UrgencyMessage,
    DestinationMessage
};

// UMD
export default {
    UrgencyMessage,
    DestinationMessage
};
